import React, { useState, useEffect, useRef } from "react";
import { ReactComponent as TrashIcon } from "../../img/trashicon.svg";
import { ReactComponent as PlusIcon } from "../../img/plusicon.svg";
import Select from "react-select";
import { instance2 } from "../../utils/axiosInstance";
import { ReactComponent as EditIcon } from "../../img/editicon.svg";
import { EyeIcon } from '@heroicons/react/16/solid';
import { ReactComponent as BackButton } from "../../img/bacbuttonicon.svg";

export default function TambahPemasok(){


  const [loadingIngredients, setLoadingIngredients] = useState(true);
  const [errorIngredients, setErrorIngredients] = useState(null);
  const [dropdowns, setDropdowns] = useState([[]]); 
  const [userId, setUserId] = useState("");
  const [ingredients, setIngredients] = useState([]);
    const [regencyId, setRegencyId] = useState([]);
      const [errorData, setErrorData] = useState(null);
        const [loadingData, setLoadingData] = useState(true);

  // Fetch regency data
  useEffect(() => {
    const fetchRegencyData = async () => {
      try {
        const response = await instance2.get("regency");
        setRegencyId(response.data); // Access the appropriate field in the response
      } catch (err) {
        setErrorData(err.message);
      } finally {
        setLoadingData(false);
      }
    };
  
    fetchRegencyData();
  }, []);

useEffect(() => {
  const categories = dropdowns.flat();
  setFormData(prev => ({
    ...prev,
    categories,
    category_count: categories.length,
  }));
}, [dropdowns]);

 useEffect(() => {
  setLoadingData(true); // Start the loading indicator
    const fetchIngredients = async () => {
      try {
        const response = await instance2.get("ingredient_category_master"); // Use instance2 for API call
        const ingredientsData = response.data.map((ingredient) => ({
          id: ingredient.id,
          name: ingredient.name,
        }));
  
        setIngredients(ingredientsData); // Update state with formatted data
      } catch (err) {
        setErrorIngredients("Failed to fetch ingredient categories"); // Handle errors
      } finally {
        setLoadingIngredients(false); // Stop loading indicator
      }
    };
    setLoadingData(false); // Start the loading indicator
  
    fetchIngredients();
  }, []);

  const preselectedOnce = useRef(false);

useEffect(() => {
  if (!loadingIngredients && !preselectedOnce.current && ingredients.length) {
    // one row that selects ALL categories
    setDropdowns([ingredients.map(i => i.id)]);
    preselectedOnce.current = true;
  }
}, [loadingIngredients, ingredients]);

  
    useEffect(() => {
      const storedUserId = localStorage.getItem("userId");
      if (storedUserId) {
        setUserId(parseInt(storedUserId, 10)); // Ensure userId is an integer
        setFormData((prev) => ({
          ...prev,
          admin_id: parseInt(storedUserId, 10), // Automatically update admin_id
        }));
      }
    }, []);
  
    
  const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
          ...prev,
          [name]: value,
        })); 
      };

 const [formData, setFormData] = useState({
    name: "",
    regency_id: "",
    address: "",
    pic: "",
    phone: "",
    email: "",
    description: "",
    admin_id: userId,
    category_count: 0, // Initial category count
    categories: [], // Array to store selected categories
  }); 

const isFormValid = () => {
  const selectedCount = dropdowns.flat().length;
  return (
    formData.name &&
    formData.pic &&
    formData.phone &&
    formData.email &&
    formData.address &&
    formData.regency_id &&
    selectedCount > 0
  );
};

 const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent the default form submission behavior
  
    try {
      const response = await instance2.post("supplier_category", formData);
  
      console.log("Success:", response.data);
  
      // Refresh the page after successful submission
  window.history.back(); // Goes to the previous page
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const updateCategories = (dropdownValues) => {
    const categories = dropdownValues.filter((value) => value !== null); // Exclude null values
    setFormData((prev) => ({
      ...prev,
      categories, // Directly store the selected category.id values
    }));
  };
  

  const updateCategoryCount = (dropdownValues) => {
    const count = dropdownValues.filter((value) => value !== null).length; // Count non-null values
    setFormData((prev) => ({
      ...prev,
      category_count: count, // Update category_count accurately
    }));
  };
  

   // Add a new dropdown
   const handleAddDropdown = () => {
    const newDropdowns = [...dropdowns, null]; // Add a new empty dropdown
    setDropdowns(newDropdowns);
    updateCategories(newDropdowns);
    updateCategoryCount(newDropdowns);
  };

  const handleDropdownChange = (value, index) => {
    const updatedDropdowns = [...dropdowns];
    updatedDropdowns[index] = value; // Update the selected value for the current dropdown
    setDropdowns(updatedDropdowns); // Update state
    updateCategories(updatedDropdowns);
    updateCategoryCount(updatedDropdowns);
  };
  const filteredIngredients = (index) => {
    const selectedIds = new Set(dropdowns.filter((item, i) => item !== null && i !== index));
    return ingredients.filter((ingredient) => !selectedIds.has(ingredient.id));
  };

// Handle dropdown deletion
const handleDeleteDropdown = (index) => {
    const newDropdowns = dropdowns.filter((_, i) => i !== index); // Remove the dropdown at the specified index
    setDropdowns(newDropdowns);
    updateCategories(newDropdowns);
    updateCategoryCount(newDropdowns);
  };

const handleChecklistToggle = (rowIndex, ingredientId, checked) => {
  setDropdowns(prev => {
    const next = [...prev];
    const current = new Set(next[rowIndex] || []);
    if (checked) current.add(ingredientId);
    else current.delete(ingredientId);
    next[rowIndex] = Array.from(current);
    return next;
  });
};


    return(
        <div className="p-4">
            <div className="flex flex-row gap-4 items-center">
                      <div className="bg-white p-2 rounded-full cursor-pointer"
                          onClick={() => window.history.back()}>
                      <BackButton 
                      className="rotate-180 text-black" />
                      </div>
                <h1 className="block text-black text-xl sm:text-2xl my-2 font-medium">Tambah Pemasok</h1>
                </div>
  
  {loadingData &&  <li className="px-4 py-8 flex justify-center">
                {/* Loading Spinner */}
                <div className="w-6 h-6 border-2 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
              </li>}

  {/* Form Section */}
  <div className="py-5">
  <div className="flex flex-col gap-6 lg:flex-row justify-between">
    {/* Left Column */}
    <div className="flex flex-col gap-4 w-full">
      <div className="flex flex-col sm:flex-row gap-4 items-center">
        <label className="block text-gray-700 w-full sm:w-1/4 text-sm">
          Nama Pemasok
        </label>
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          className="w-full px-3 border-none rounded-[50px] bg-white text-xs py-4"
          placeholder="Nama Pemasok"
        />
      </div>
      <div className="flex flex-col gap-4">
    {dropdowns.map((selectedIds = [], index) => {
  const dateLabel = index === 0 ? "Kategori Bahan" : "";
  const list = filteredIngredients(index);

  return (
    <div
      key={index}
      className="flex flex-col sm:flex-row relative gap-4 items-start sm:items-center justify-end"
    >
      <label className="block text-gray-700 w-full sm:w-1/4">
        {dateLabel}
      </label>

      <div className="w-full rounded-2xl bg-white p-3">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
          {list.map((ingredient) => {
            const isChecked = (selectedIds || []).includes(ingredient.id);
            return (
              <label
                key={ingredient.id}
                className="inline-flex items-center gap-2 text-sm"
              >
                <input
                  type="checkbox"
                  className="h-4 w-4 rounded border-gray-300"
                  checked={isChecked}
                  onChange={(e) =>
                    handleChecklistToggle(index, ingredient.id, e.target.checked)
                  }
                />
                <span>{ingredient.name}</span>
              </label>
            );
          })}
        </div>

        {/* Optional quick actions */}
        <div className="mt-3 flex gap-3 text-xs">
          <button
            type="button"
            className="underline"
            onClick={() =>
              setDropdowns(prev => {
                const next = [...prev];
                next[index] = list.map(i => i.id); // select all visible
                return next;
              })
            }
          >
            Pilih semua
          </button>
          <button
            type="button"
            className="underline"
            onClick={() =>
              setDropdowns(prev => {
                const next = [...prev];
                next[index] = []; // clear all
                return next;
              })
            }
          >
            Hapus semua
          </button>
        </div>
      </div>

      {index > 0 && (
        <button
          onClick={() => handleDeleteDropdown(index)}
          className="absolute py-2 px-2 text-gray-500 hover:text-red-600"
          style={{ right: "-28px" }}
          title="Hapus baris"
        >
          <TrashIcon className="w-4 h-4" />
        </button>
      )}
    </div>
  );
})}

      </div>
    </div>

    {/* Center Column */}
    <div className="flex flex-col gap-4 w-full">
      <div className="flex flex-col sm:flex-row gap-4 items-center">
        <label className="block text-gray-700 w-full sm:w-1/4 text-sm">
          Narahubung
        </label>
        <input
          type="text"
          name="pic"
          value={formData.pic}
          onChange={handleChange}
          className="w-full px-3 border-none rounded-[50px] bg-white text-xs py-4"
          placeholder="Narahubung"
        />
      </div>
      <div className="flex flex-col sm:flex-row gap-4 items-center">
        <label className="block text-gray-700 w-full sm:w-1/4 text-sm">No HP</label>
        <input
          type="tel"
          name="phone"
          value={formData.phone}
          onChange={(e) => {
            const cleanedValue = e.target.value.replace(/\D/g, "");
            handleChange({ target: { name: e.target.name, value: cleanedValue } });
          }}
          className="w-full px-3 border-none rounded-[50px] bg-white text-xs py-4"
          placeholder="Nomor HP"
          maxLength="15"
        />
      </div>
      <div className="flex flex-col sm:flex-row gap-4 items-center">
        <label className="block text-gray-700 w-full sm:w-1/4 text-sm">Catatan</label>
        <input
          type="text"
          name="description"
          value={formData.description}
          onChange={handleChange}
          className="w-full px-3 border-none rounded-[50px] bg-white text-xs py-4"
          placeholder="Catatan"
        />
      </div>
    </div>

    {/* Right Column */}
    <div className="flex flex-col gap-4 w-full">
      <div className="flex flex-col sm:flex-row gap-4 items-center">
        <label className="block text-gray-700 w-full sm:w-1/4 text-sm">
          Alamat Email
        </label>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          className="w-full px-3 border-none rounded-[50px] bg-white text-xs py-4"
          placeholder="Alamat Email"
        />
      </div>
      <div className="flex flex-col sm:flex-row gap-4 items-center">
        <label className="block text-gray-700 w-full sm:w-1/4 text-sm">
          Kota / Kabupaten
        </label>
        <Select
          value={
            regencyId
              .map((reg) => ({
                value: reg.id,
                label: reg.name,
              }))
              .find((option) => option.value === formData.regency_id) || null
          }
          onChange={(selectedOption) => {
            setFormData((prev) => ({
              ...prev,
              regency_id: selectedOption ? selectedOption.value : null,
            }));
          }}
          options={regencyId.map((reg) => ({
            value: reg.id,
            label: reg.name,
          }))}
          className="w-full rounded-full text-xs"
          placeholder="Pilih Koperasi"
          isSearchable={true}
          styles={{
            control: (base) => ({
              ...base,
              border: "none",
              boxShadow: "none",
              borderRadius: "999px",
              padding: "4px 8px",
            }),
            valueContainer: (base) => ({
              ...base,
              padding: "8px",
            }),
            option: (base) => ({
              ...base,
              padding: "8px 12px",
            }),
            dropdownIndicator: (base) => ({
              ...base,
              color: "gray",
              padding: "4px",
            }),
            clearIndicator: (base) => ({
              ...base,
              color: "gray",
            }),
            indicatorSeparator: () => ({
              display: "none",
            }),
          }}
        />
      </div>
      <div className="flex flex-col sm:flex-row gap-4 items-center">
        <label className="block text-gray-700 w-full sm:w-1/4 text-sm">
          Alamat Perusahaan
        </label>
        <textarea
          name="address"
          value={formData.address}
          onChange={handleChange}
          className="w-full px-3 border-none rounded-[50px] bg-white text-xs py-4"
          placeholder="Alamat Perusahaan"
        />
      </div>
    </div>
  </div>

  {/* Submit Button */}
  <div className="w-full flex flex-col sm:flex-row justify-center mt-4 px-4 sm:px-8 gap-5">
        <button
        className="bg-merah-no py-5 px-8 text-white rounded-[30px] hover:bg-merah-hover"
          onClick={() => {window.history.back()}}
        >
          Kembali
        </button>
    <button
      onClick={handleSubmit}
          disabled={!isFormValid()}
          className={`py-5 px-8 rounded-[30px] text-sm transition-colors duration-300 ${
            isFormValid()
              ? "bg-merah-no text-white hover:bg-merah-hover"
              : "bg-gray-300 text-gray-500 cursor-not-allowed"
          }`}
    >
      Tambah Pemasok
    </button>
  </div>
  </div>
        </div>
    )
}